module.exports = __webpack_public_path__ + "static/media/sprite.e7bbbad4.svg";